import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  CardWrapper,
  Heading
} from './style';
import {
  LeaderboardRow,
  LeaderboardHeader,
  UserColumn,
  AnswerColumn,
  RankColumn,
  NewUserName
} from '../ChallengeDetailsV2/ChallengeLeaderboardV2/styles';
import { Waiting } from '../../components';
import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';
import { ImageUrl } from '../../utils/constants';
import { commaSeperator, convertMilesToKm } from '../../utils/methods';
import { withTranslation } from 'react-i18next';
import LazyImage from '../common/LazyImage/LazyImage';

const RANK_STYLES = {
  1: {
    background: 'linear-gradient(90deg, #F0D779 0%, #E3C350 100%)', // Gold
    color: '#184A61',
    border: 'none'
  },
  2: {
    background: 'linear-gradient(90deg, #E6E9F0 0%, #DCDCDC 100%)', // Silver
    color: '#184A61',
    border: 'none'
  },
  3: {
    background: 'linear-gradient(91deg, #9A5426 -51.95%, #EBAB80 57.55%, #9A5426 210.37%)',
    color: '#184A61',
    border: 'none'
  },
  default: {
    background: '#FFFFFF',
    color: '#184A61',
    border: '1px solid #E8E8E8'
  }
};

class FitnessActivityData extends Component {

  fallBack = (e) => {
    e.target.src = '/public/images/defaultProfileImg.png'
  }

  leaderboardLimit = () => {
    const { getTopFitnessLeaderboard, companyId, userLimit, pageNumber, updateLimit } = this.props;
    updateLimit();
    let pageCount;
    pageCount = pageNumber + 1;
    getTopFitnessLeaderboard(companyId, pageCount, userLimit);
  }

  onScroll = (e) => {
    const bottom = Math.round(e.target.scrollHeight - parseInt(e.target.scrollTop, 10)) === Math.round(e.target.clientHeight);
    if (bottom) {
      this.leaderboardLimit()
    }
  };

  getValueAndUnit = (data) => {
    const { activeBuddiesPoints, t } = this.props;
    const DistanceUnit = localStorage.getItem('DISTANCE');

    if (activeBuddiesPoints === "5") { // Steps
      return {
        value: data.total_steps ? commaSeperator(data.total_steps) : 0,
        unit: t("steps"),
        rawValue: data.total_steps || 0
      };
    } else if (activeBuddiesPoints === "6") { // Calories
      return {
        value: data.total_calories ? commaSeperator(data.total_calories) : 0,
        unit: t("kcal"),
        rawValue: data.total_calories || 0
      };
    } else if (activeBuddiesPoints === "7") { // Distance
      const isKm = DistanceUnit === "KILOMETER";
      
      const rawDistance = data.total_distance || 0;
      
      const distanceVal = rawDistance > 0
        ? (isKm ? commaSeperator(convertMilesToKm(data.total_distance)) : commaSeperator(data.total_distance))
        : 0;
        
      return {
        value: distanceVal,
        unit: isKm ? t("km") : t("miles"),
        rawValue: rawDistance
      };
    }
    return { value: 0, unit: "", rawValue: 0 };
  }

  getRawValueForSort = (data) => {
    const { activeBuddiesPoints } = this.props;
    if (activeBuddiesPoints === "5") return data.total_steps || 0;
    if (activeBuddiesPoints === "6") return data.total_calories || 0;
    if (activeBuddiesPoints === "7") return data.total_distance || 0;
    return 0;
  }

  renderTitle = () => {
    const { activeBuddiesPoints, t } = this.props;
    if (activeBuddiesPoints === "5") return t("Steps Completed");
    if (activeBuddiesPoints === "6") return t("Calories Burned");
    if (activeBuddiesPoints === "7") return t("Distance Traveled");
    return "";
  }

  render() {
    const { activeBuddiesPoints, distanceLeaderboard, stepsLeaderboard, caloriesLeaderboard, t } = this.props;

    if (activeBuddiesPoints === "5" && isEmpty(stepsLeaderboard)) return <Waiting />;
    if (activeBuddiesPoints === "6" && isEmpty(caloriesLeaderboard)) return <Waiting />;
    if (activeBuddiesPoints === "7" && isEmpty(distanceLeaderboard)) return <Waiting />;

    let fitnessActivityData = [];
    if (activeBuddiesPoints === "5") fitnessActivityData = stepsLeaderboard;
    else if (activeBuddiesPoints === "6") fitnessActivityData = caloriesLeaderboard;
    else if (activeBuddiesPoints === "7") fitnessActivityData = distanceLeaderboard;

    if (isUndefined(fitnessActivityData) || isEmpty(fitnessActivityData)) return null;

    const sortedData = [...fitnessActivityData].sort((a, b) => {
      const valA = this.getRawValueForSort(a);
      const valB = this.getRawValueForSort(b);

      if (valB !== valA) return valB - valA;
      
      const nameA = a.name || "";
      const nameB = b.name || "";
      return nameA.localeCompare(nameB);
    });

    let valueHeader = t("Steps");
    if (activeBuddiesPoints === "6") valueHeader = t("Calories"); 
    if (activeBuddiesPoints === "7") valueHeader = t("Distance");

    return (
      <React.Fragment>
        <CardWrapper onScroll={this.onScroll}>
          {/* Title */}
          <Heading style={{ fontSize: '24px', fontWeight: '700', color: '#184A61', marginBottom: '20px' }}>
            {this.renderTitle()}
          </Heading>

          <div style={{ width: '100%', marginTop: '10px' }}>
            {/* Header */}
            <LeaderboardHeader>
              <UserColumn style={{ paddingLeft: '20px' }}>{t("User Name")}</UserColumn>
              <AnswerColumn style={{ textAlign: 'left', paddingRight: '40px' }}>{valueHeader}</AnswerColumn>
              <RankColumn style={{ width: "auto", textAlign: 'left', paddingRight: '20px' }}>{t("Rank")}</RankColumn>
            </LeaderboardHeader>

            {/* List */}
            {sortedData.map((data, index) => {
              const rank = index + 1;
              const { value, unit, rawValue } = this.getValueAndUnit(data);
              const rankSuffix = rank === 1 ? "st" : rank === 2 ? "nd" : rank === 3 ? "rd" : "th";
              
              let styleConfig = RANK_STYLES.default;
              let rankDisplay = (
                <>
                  <span>{rank}{rankSuffix}</span>
                  <span style={{ fontWeight: '400' }}> &nbsp;{t("Rank")}</span>
                </>
              );

              // Check if values are 0 (which sets Rank to N/A)
              const isZeroData = rawValue === 0 || rawValue === "0";

              // Conditional padding for Steps/Value. 48px if N/A, 40px (default header alignment) if data exists.
              const answerPadding = isZeroData ? '70px' : '40px';

              if (isZeroData) {
                styleConfig = RANK_STYLES.default;
                rankDisplay = <span>N/A</span>;
              } else if (RANK_STYLES[rank]) {
                styleConfig = RANK_STYLES[rank];
              }

              return (
                <LeaderboardRow
                  key={index}
                  style={{
                    background: styleConfig.background,
                    border: styleConfig.border,
                    color: styleConfig.color,
                    marginBottom: '10px',
                    borderRadius: '8px',
                    padding: '10px 0',
                    alignItems: 'center',
                    minHeight: '60px'
                  }}
                >
                  {/* User Column */}
                  <UserColumn style={{ paddingLeft: '20px', display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '48px', height: '48px' }}>
                      <LazyImage
                        style={{ width: "48px", height: "48px", borderRadius: "50%", objectFit: 'cover' }}
                        onError={this.fallBack}
                        src={`${ImageUrl}/${data.profile_image}`}
                        alt="Profile"
                      />
                    </div>
                    <NewUserName style={{ marginLeft: "20px", fontWeight: '600', fontSize: '16px', color: '#184A61' }}>
                      {data.name}
                    </NewUserName>
                  </UserColumn>

                  {/* Value Column - Adjusts padding if no data to 48px, otherwise stays 40px */}
                  <AnswerColumn style={{ textAlign: 'left', paddingRight: answerPadding, fontWeight: '500', color: '#184A61' }}>
                    {value}&nbsp; <span style={{ fontSize: '16px', fontWeight: '400' }}>{unit}</span>
                  </AnswerColumn>

                  {/* Rank Column - Padding kept consistent at 20px for both data and N/A */}
                  <RankColumn style={{ width: "auto", textAlign: 'left', paddingRight: '20px', color: '#184A61' }}>
                    {rankDisplay}
                  </RankColumn>
                </LeaderboardRow>
              );
            })}
          </div>
        </CardWrapper>
      </React.Fragment>
    )
  }
}

FitnessActivityData.propTypes = {
  history: PropTypes.object.isRequired,
  fitnessLeaderboard: PropTypes.object,
  activeBuddiesPoints: PropTypes.string,
  leaderboardLimit: PropTypes.func,
  companyId: PropTypes.number,
  userLimit: PropTypes.number,
  updateLimit: PropTypes.func,
  pageNumber: PropTypes.number,
  getTopFitnessLeaderboard: PropTypes.func,
  distanceLeaderboard: PropTypes.object,
  stepsLeaderboard: PropTypes.object,
  caloriesLeaderboard: PropTypes.object,
  t: PropTypes.func
};

export default (withTranslation()(FitnessActivityData));